const footerES = {
	links: {
		about: "Sobre Nosotros",
		privacy: "Política de Privacidad",
		terms: "Términos de Servicio",
		contact: "Contacto",
		refundPolicy: "Política de Reembolso"
	},
	apps: {
		appStoreAria: "Descárgalo en App Store",
		googlePlayAria: "Disponible en Google Play",
	},
	languageSwitch: "English",
};

export default footerES;